import { render, staticRenderFns } from "./partgroups.vue?vue&type=template&id=734d95bb&lang=pug"
import script from "./partgroups.vue?vue&type=script&lang=js"
export * from "./partgroups.vue?vue&type=script&lang=js"
import style0 from "./partgroups.vue?vue&type=style&index=0&id=734d95bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports